import { useGlobalStore } from '../stores/globalStore';

/**
 * PSI staff sign in with a psibuffalo.com login. The API applies the same rule
 * (Services/PsiStaff.cs) and is what actually enforces it; this only decides
 * what the menu shows.
 */
export const PSI_EMAIL_DOMAIN = '@psibuffalo.com';

export function isPsiEmail(email: string | null | undefined): boolean {
  return !!email && email.trim().toLowerCase().endsWith(PSI_EMAIL_DOMAIN);
}

/** PSI staff, or any login on a dev build (the API's DebugSettings allowance). */
export function isPsiStaffOrDev(email: string | null | undefined): boolean {
  return import.meta.env.DEV || isPsiEmail(email);
}

/**
 * User administration happens in Tech Log II, not here (Jeff, 2026-10-10): the API takes user and
 * user-mapping writes from PSI staff only, and the Users pages are PSI-only to match.
 */
export const USERS_MANAGED_IN_TECH_LOG = 'Users are managed by PSI. Contact PSI support to add or change a user.';

export function useIsPsiStaff(): boolean {
  return isPsiStaffOrDev(useGlobalStore((s) => s.userEmail));
}

/**
 * Help > Pages (every page, its address, and the planned help videos) is an internal list: Jeff, 2026-10-26,
 * "give it to just dietechremote@psibuffalo.com". A dev build shows it too, as for the other PSI-only screens.
 */
export const HELP_PAGES_EMAIL = 'dietechremote@psibuffalo.com';

export function canSeeHelpPages(email: string | null | undefined): boolean {
  return import.meta.env.DEV || (!!email && email.trim().toLowerCase() === HELP_PAGES_EMAIL);
}

export function useCanSeeHelpPages(): boolean {
  return canSeeHelpPages(useGlobalStore((s) => s.userEmail));
}
